import React from 'react'
import PropTypes from 'prop-types'
import { Routes } from 'app/services/routeService/routeService'

import { SECONDARY } from 'app/constants/button'

import ContainedButton from './ContainedButton'

const ButtonToSignup = ({ text = 'Go back to Sign up methods', ...rest }) => (
  <div className="flex justify-center mt-10">
    <ContainedButton
      type="submit"
      color={SECONDARY}
      className="w-full h-48 text-white no-underline"
      href={Routes.signIn()}
      {...rest}
    >
      {text}
    </ContainedButton>
  </div>
)

ButtonToSignup.propTypes = {
  text: PropTypes.string,
}

export default ButtonToSignup
